import { properties } from '../properties';

export default function apiFetch(url, options = {}) {
    return fetch(url, {
        ...options,
        credentials: 'include', // envia o cookie httpOnly automaticamente
    });
}

// Wrapper para as chamadas aos endpoints de auth (login, logout, me)
export function authFetch(path, options = {}) {
    return fetch(`${properties.baseURL}${path}`, {
        ...options,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', ...options.headers },
    });
}
